const SECONDS_IN_MINUTE = 60
const SECONDS_IN_HOUR = 3600

export const formatDuration = (seconds) => {
  if (!Number.isInteger(seconds) || seconds < 0) {
    return ''
  }

  if (seconds < SECONDS_IN_MINUTE) {
    return `${seconds} s`
  }

  if (seconds < SECONDS_IN_HOUR) {
    const minutes = Math.floor(seconds / SECONDS_IN_MINUTE)
    const remainingSeconds = seconds % SECONDS_IN_MINUTE

    return remainingSeconds ? `${minutes} min ${remainingSeconds} s` : `${minutes} min`
  }

  const hours = Math.floor(seconds / SECONDS_IN_HOUR)
  const remainingMinutes = Math.floor((seconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE)

  return remainingMinutes ? `${hours} h ${remainingMinutes} min` : `${hours} h`
}
